export const mainPage = {
  type: 'Select type',
  subtype: 'Select subtype',
  brand: 'Select brand',
  brandModel: 'Select model',
}
